import moment from 'moment';

const dateMixin = { 
    methods: {
        dateFormat(date, format = 'MMMM Do YYYY') {
            return moment(date).format(format)
        },
        numberToHour(date) {
            return `${date / 60}h`
        },
        getNumberOfDays(from, to) {
            const day = 1000 * 60 * 60 * 24;

            const start = new Date(from);
            start.setHours(0);
            const end = new Date(to);
            end.setHours(24);
             
            return Math.round((end.valueOf() - start.valueOf() )/ day)
        }
    }
}

export default dateMixin;